package dev.lingvo.ops.state

import dev.lingvo.shared.ops.OpsJobHealthDto
import dev.lingvo.shared.ops.OpsProviderKeyHealthDto
import dev.lingvo.shared.ops.OpsSentinelState
import dev.lingvo.shared.ops.OpsSeatHealthDto
import dev.lingvo.shared.ops.OpsWindow
import dev.lingvo.shared.ops.OpsWebhookRowDto

data class OpsAttentionItem(val title: String, val detail: String, val href: String, val count: Int)

fun attentionItems(
    jobs: OpsJobHealthDto,
    webhooks: OpsWindow<OpsWebhookRowDto>,
    checkouts: OpsWindow<dev.lingvo.shared.ops.OpsCheckoutRowDto>,
    seats: OpsSeatHealthDto,
    keys: OpsProviderKeyHealthDto,
): List<OpsAttentionItem> = buildList {
    if (jobs.failedSince > 0 || jobs.unrefundedAbandoned.isNotEmpty()) {
        val count = jobs.failedSince + jobs.unrefundedAbandoned.size
        add(OpsAttentionItem("Translation jobs need review", "${count} failed or abandoned job(s).", "/jobs", count))
    }
    if (webhooks.rows.isNotEmpty()) add(
        OpsAttentionItem("Webhooks are failing", "${webhooks.rows.size} webhook(s) need review.", "/webhooks", webhooks.rows.size),
    )
    if (checkouts.rows.isNotEmpty()) add(
        OpsAttentionItem("Checkouts need review", "${checkouts.rows.size} checkout(s) remain unsettled.", "/workspaces", checkouts.rows.size),
    )
    if (seats.rows.isNotEmpty()) add(
        OpsAttentionItem("Seat counts diverge", "${seats.rows.size} workspace(s) differ outside their sync window.", "/workspaces", seats.rows.size),
    )
    if (keys.sentinel != OpsSentinelState.VERIFIED || keys.unreadableKeys > 0) {
        val count = (keys.unreadableKeys.coerceAtMost(Int.MAX_VALUE.toLong())).toInt().coerceAtLeast(1)
        val detail = if (keys.sentinel == OpsSentinelState.UNTESTED) {
            "The provider-key sentinel has not been checked."
        } else {
            "$count provider key finding(s) need review."
        }
        add(OpsAttentionItem("Provider keys need review", detail, "/platform", count))
    }
}
